import {
	constructionMaterialCalculationConstants
}from './constants'
import actions from '../../actions'

const initialState =
{
	isSending : false,
	paged     : null,
	list      : null,
	changed   : null
}

export default function (state = initialState, action){
	switch (action.type){
		case constructionMaterialCalculationConstants.GetPaged.REQUEST:
		case constructionMaterialCalculationConstants.Create.REQUEST:
		case constructionMaterialCalculationConstants.Delete.REQUEST:
		case constructionMaterialCalculationConstants.Restore.REQUEST:
		case constructionMaterialCalculationConstants.Update.REQUEST:
		case constructionMaterialCalculationConstants.UpdateByFile.REQUEST:
		case constructionMaterialCalculationConstants.DeleteFiltered.REQUEST:
		case constructionMaterialCalculationConstants.DeleteSelected.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case constructionMaterialCalculationConstants.GetExampleFile.REQUEST:
			return {
				...state,
				isTemplateDownloaded: true
			}
		case constructionMaterialCalculationConstants.GetPaged.FAILURE:
		case constructionMaterialCalculationConstants.Create.FAILURE:
		case constructionMaterialCalculationConstants.Delete.FAILURE:
		case constructionMaterialCalculationConstants.Restore.FAILURE:
		case constructionMaterialCalculationConstants.Update.FAILURE:
		case constructionMaterialCalculationConstants.UpdateByFile.FAILURE:
		case constructionMaterialCalculationConstants.GetExampleFile.FAILURE:
		case constructionMaterialCalculationConstants.DeleteFiltered.FAILURE:
		case constructionMaterialCalculationConstants.DeleteSelected.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case constructionMaterialCalculationConstants.GetPaged.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case constructionMaterialCalculationConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case constructionMaterialCalculationConstants.Delete.SUCCESS:
		case constructionMaterialCalculationConstants.DeleteFiltered.SUCCESS:
		case constructionMaterialCalculationConstants.DeleteSelected.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case constructionMaterialCalculationConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case constructionMaterialCalculationConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}
		case constructionMaterialCalculationConstants.UpdateByFile.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.download : null
			}
		case constructionMaterialCalculationConstants.GetExampleFile.SUCCESS:
			return {
				...state,
				isTemplateDownloaded: false
			}
		case constructionMaterialCalculationConstants.Clear:
			return {
				...state,
				changed   : null,
				isSending : false,
				paged     : null,
				list      : null
			}
		default:
			return state
	}
}